import { useMemo, useCallback } from 'react';
import { useSelector } from 'react-redux';
import { selectSingleObjectActiveTab } from '../../../../reducers/documentation/salesforceDocumentationReducer';
import { useExpandedMode } from '../../../pages/configuration-canvas/panels-reserve-space/useExpandedMode';
import { FiltersRenderer } from '../../../common/filters/filters-renderer/FiltersRenderer';
import { useDocumentationFiltersContext } from './DocumentationFiltersContext';
import { useDocumentationFilters } from './useDocumentationFilters';
import { checkFiltersHaveValuesCb } from './utils';

export const DocumentationFilters = ({
  forceCompact,
  crmOrgId,
}: {
  forceCompact?: boolean;
  crmOrgId: string;
}) => {
  const { filters } = useDocumentationFilters(crmOrgId);
  const activeTab = useSelector(selectSingleObjectActiveTab);
  const { isExpandedMode } = useExpandedMode();
  const { filterValues, setFilterValue, clearAllFilterValues } = useDocumentationFiltersContext();

  const handleFilterChange = useCallback(
    (filterKey: string, values: string[]) => {
      setFilterValue(filterKey, values);
    },
    [setFilterValue],
  );

  // Convert filters to FiltersRenderer format and sort by position
  const sortedFilters = useMemo(() => {
    if (!filters) return {};

    // Sort by position and return as ordered object
    const sortedEntries = Object.entries(filters)
      .filter(([key]) => key in filters)
      .map(([key]) => [key, filters[key]]);

    return Object.fromEntries(sortedEntries);
  }, [filters]);

  if (!activeTab) return null;

  const withPanelWrapper = forceCompact || !isExpandedMode;

  return (
    <FiltersRenderer
      filters={sortedFilters}
      filterValues={filterValues}
      onFilterChange={handleFilterChange}
      onClearAll={clearAllFilterValues}
      withPanelWrapper={withPanelWrapper}
      gap={2}
      checkFiltersHaveValuesCb={checkFiltersHaveValuesCb}
    />
  );
};
